import React, { useState } from "react";
import { Link } from "react-scroll";
import { BiMenu } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { FaHome, FaUserAlt, FaTools, FaProjectDiagram, FaBriefcase, FaEnvelope } from "react-icons/fa";
import Logo from "../assets/Images/PNGIA.png";

const links = [
  { title: "Home", link: "home", icon: <FaHome /> },
  { title: "About", link: "about", icon: <FaUserAlt /> },
  { title: "Educations", link: "Skills", icon: <FaTools /> },
  { title: "Projects", link: "Projects", icon: <FaProjectDiagram /> },
  { title: "Experience", link: "experience", icon: <FaBriefcase /> },
  { title: "Contact", link: "contact", icon: <FaEnvelope /> },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("home");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="text-white fixed inset-x-0 top-0 z-50 bg-darkblue shadow-md">
      <div className="container mx-auto flex justify-between items-center py-4 px-6 lg:px-10">
        {/* Logo */}
        <Link
          spy={true}
          smooth={true}
          offset={-100}
          duration={750}
          to="home"
          className="flex items-center cursor-pointer"
          onClick={() => setActiveLink("home")}
        >
          <img src={Logo} alt="Logo" className="w-10 h-10 lg:w-12 lg:h-12" />
          <span className="ml-3 text-xl font-bold tracking-wide hidden lg:block">IMALI AZZEDDINE</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex space-x-8 items-center">
          {links.map((item) => (
            <Link
              key={item.title}
              spy={true}
              smooth={true}
              offset={-100}
              duration={750}
              to={item.link}
              onSetActive={() => setActiveLink(item.link)}
              className={`flex items-center gap-2 text-lg cursor-pointer transition ${
                activeLink === item.link ? "text-orange-500 border-b-2 border-orange-500" : "hover:text-orange-500"
              }`}
            >
              {item.icon}
              <span>{item.title}</span>
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="lg:hidden text-2xl p-2 focus:outline-none"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <MdClose /> : <BiMenu />}
        </button>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="absolute top-16 left-0 w-full bg-darkblue shadow-lg">
            <nav className="flex flex-col items-center space-y-6 py-6">
              {links.map((item) => (
                <Link
                  key={item.title}
                  onClick={() => {
                    setIsMenuOpen(false);
                    setActiveLink(item.link);
                  }}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={750}
                  to={item.link}
                  className={`flex items-center gap-2 text-lg cursor-pointer transition ${
                    activeLink === item.link ? "text-orange-500" : "hover:text-orange-500"
                  }`}
                >
                  {item.icon}
                  <span>{item.title}</span>
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
